import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { formatCount } from "./UsageTable"
import { downloadCsv } from "./exportCsv"
import EnterpriseMetricTooltip, { getMetricEnterprises } from "./EnterpriseMetricTooltip"

const primaryTypes = [
    ["administrador", "Administrador"], ["supervisor", "Supervisor"], ["operador", "Operador"],
]

const ModuleAccessByTypeOverview = ({ rows, enterprises = [] }) => {
    const modules = rows.filter(row => row.access_tracked)
    const types = [...primaryTypes, ...[["other", "Outros / sem perfil"], ["", "Histórico sem perfil"]]
        .filter(([key]) => modules.some(row => (row.accesses_by_type?.[key] || 0) > 0))]
    const csvRows = modules.map(row => ({
        ...row,
        ...Object.fromEntries(types.map(([key]) => [`role_${key}`, row.accesses_by_type?.[key] || 0])),
    }))

    return (
        <Accordion disableGutters variant="outlined" sx={{ borderRadius: 2, "&::before": { display: "none" } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="module-access-by-type-content" id="module-access-by-type-heading">
                <Box>
                    <Typography variant="h5">Tipos de usuário</Typography>
                    <Typography variant="body2" color="text.secondary">Acessos aos módulos por Administrador, Supervisor e Operador</Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ p: { xs: 2, md: 3 } }} id="module-access-by-type-content">
        <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 }, borderRadius: 2, minWidth: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButton size="small" aria-label="Baixar CSV: módulos por tipo de usuário" title="Baixar CSV: módulos por tipo de usuário" onClick={() => downloadCsv("kwik-modulos-por-tipo-de-usuario.csv", [
                    { key: "label", label: "Módulo" }, { key: "accesses", label: "Total de acessos" },
                    ...types.map(([key, label]) => ({ key: `role_${key}`, label })),
                ], csvRows)}><DownloadIcon fontSize="small" /></IconButton>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Total de acessos às guias nas empresas e no período consultados. Outros perfis e histórico sem perfil aparecem quando houver registros.
            </Typography>
            <TableContainer sx={{ overflowX: "auto", mt: 2 }}>
                <Table size="small" aria-label="Módulos por tipo de usuário" sx={{ minWidth: 700 }}>
                    <TableHead sx={{ bgcolor: "#F1F5F9" }}><TableRow>
                        <TableCell>Módulo</TableCell><TableCell align="right">Total de acessos</TableCell>
                        {types.map(([, label]) => <TableCell key={label} align="right">{label}</TableCell>)}
                    </TableRow></TableHead>
                    <TableBody>
                        {modules.map(row => <TableRow key={row.id} hover>
                            <TableCell component="th" scope="row">{row.label}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 700, color: "#21446C" }}><EnterpriseMetricTooltip
                                enterprises={getMetricEnterprises(enterprises, "modules", row.id, "accesses")}
                                getValue={enterprise => formatCount(enterprise.modules[row.id].accesses)}>{formatCount(row.accesses)}</EnterpriseMetricTooltip></TableCell>
                            {types.map(([key]) => <TableCell key={key} align="right"><EnterpriseMetricTooltip
                                enterprises={getMetricEnterprises(enterprises, "modules", row.id, state => state.accesses_by_type?.[key])}
                                getValue={enterprise => formatCount(enterprise.modules[row.id].accesses_by_type?.[key] || 0)}>
                                {formatCount(row.accesses_by_type?.[key] || 0)}
                            </EnterpriseMetricTooltip></TableCell>)}
                        </TableRow>)}
                        {!modules.length && <TableRow><TableCell colSpan={2 + types.length}>Nenhum acesso identificado no período.</TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
            </AccordionDetails>
        </Accordion>
    )
}

export default ModuleAccessByTypeOverview
